import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const OSStandardFilterFields = iotsUtils.fromList(
	constants.wholeHouse.usage.osStandardFilterFields
);

export const OSDateFilterFields = iotsUtils.fromList(constants.wholeHouse.usage.osDateFilterFields);

export const FilterField = iotsUtils.fromList(constants.wholeHouse.usage.filterFields);
